import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'deviceBattery'
})
export class DeviceBatteryPipe implements PipeTransform {

    transform(value: string): any {

        if (!value) {
            return '';
        }

        return ((parseInt(value) - 280) * 100) / 140;
    }
}
